export const externalLinks = {
    appGoolge: "https://play.google.com/store/apps/details?id=com.findallnepal.mobile_client&hl=en_US&gl=US",
    appApple: "https://www.apple.com/app-store/",
}


